<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                Анкеты
            </template>
            <h2>Анкеты</h2>
        </page-header>
        <section class="content">
            <template v-if="page && page.items.length">
                <div class="table-inner">
                    <table class="table-custom">
                        <thead>
                        <tr>
                            <th width="50px"></th>
                            <th>Название</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in page.items" :key="item.id" v-on:dblclick="editCard(item.id)">
                                <td><menu-component class="actions" :actions="actions(item)" /></td>
                                <td>{{item.name}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-else>
                <EmptyListMessage/>
            </template>
        </section>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import Api from "../api/poll";
  import EmptyListMessage from "../../../common/components/EmptyListMessage";
  import MenuComponent from "../../../common/ui/components/page/MenuComponent";
  export default {
    name: "Polls",
    components: {MenuComponent, EmptyListMessage, PageHeader},
    data() {
      return {
        page: {
          items: []
        },
        canEdit: true
      }
    },
    created() {
      this.loadPage();
    },
    methods: {
      actions(item) {
        return [
          {
            title: 'Редактировать',
            icon: 'pen',
            click: () => {if(this.canEdit) this.editCard(item.id)}
          }
        ];
      },
      loadPage() {
        Api.search({}).then((response) => {
          this.page = response.data;
        });
      },
      editCard(id) {
        this.$router.push({ name: 'PollCard', params: { action: 'edit', id: id }});
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .content{
        padding: 16px 16px 0 16px;
        position: relative;
        overflow-y: visible;
    }
</style>